import React from 'react'
import {Icon} from '@salesforce/retail-react-app/app/components/shared/ui'

const ChefIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path
                d="M24.1902 11.8075C32.0892 11.8075 38.493 18.2113 38.493 26.1103C38.493 32.8926 33.7365 38.6927 27.2099 40.0936C27.2153 40.0911 27.2709 42.0404 27.2709 42.0404C34.852 40.5827 40.413 33.9214 40.413 26.1103C40.413 17.1509 33.1496 9.88749 24.1902 9.88749V11.8075Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.4514 26.1101C28.4514 28.1337 27.0413 29.8282 25.1502 30.2639V42.1905H23.2302V30.264C21.3388 29.8285 19.9284 28.1339 19.9284 26.1101C19.9284 23.7565 21.8362 21.8486 24.1899 21.8486C26.5436 21.8486 28.4514 23.7565 28.4514 26.1101ZM26.5314 26.1101C26.5314 24.8168 25.4832 23.7686 24.1899 23.7686C22.8966 23.7686 21.8484 24.8168 21.8484 26.1101C21.8484 27.4037 22.8969 28.4525 24.1899 28.4525C25.483 28.4525 26.5314 27.4037 26.5314 26.1101Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.0497 0H18.3307C17.8005 0 17.3707 0.429807 17.3707 0.96C17.3707 1.49019 17.8005 1.92 18.3307 1.92H23.2304V4.82122C18.8337 5.01608 14.7832 6.54328 11.473 9.00889L9.88704 6.99965L8.37997 8.18924L9.98599 10.2239C5.62473 14.126 2.87988 19.7976 2.87988 26.1101C2.87988 37.8794 12.4211 47.4212 24.19 47.4212C35.959 47.4212 45.5002 37.8794 45.5002 26.1101C45.5002 19.6743 42.6471 13.9048 38.1368 9.99739L39.7564 7.9456L38.2493 6.75601L36.6307 8.80651C33.3727 6.45997 29.4253 5.01086 25.1504 4.82125V1.92H30.0497C30.5799 1.92 31.0097 1.49019 31.0097 0.96C31.0097 0.429807 30.5799 0 30.0497 0ZM24.19 6.72C34.8988 6.72 43.5802 15.4014 43.5802 26.1101C43.5802 36.8191 34.8986 45.5012 24.19 45.5012C13.4815 45.5012 4.79988 36.8191 4.79988 26.1101C4.79988 15.4014 13.4813 6.72 24.19 6.72Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ChefIcon
